import Alpine from 'alpinejs';

import { NotificationStore } from './notification';

export const getNotificationStore = (): NotificationStore => {
    if (!Alpine.store('notification')) {
        Alpine.store('notification', new NotificationStore());
    }

    return Alpine.store('notification') as NotificationStore;
};
